import { render, staticRenderFns } from "./loader-modal.vue?vue&type=template&id=3a969fdb&"
import script from "./loader-modal.vue?vue&type=script&lang=js&"
export * from "./loader-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports